import {
  AddressInput,
  AddressValidationType,
  ChannelType,
  Query,
  SuggestedAddress,
  Typenames,
} from '@varo/graphql-schema-types';
import { useEffect, useState } from 'react';
import ValidateAddressV2 from 'services/graphql/queries/ValidateAddressV2';
import { useQuery } from 'urql';

export enum AddressView {
  FormAddress = 'FormView',
  SuggestedAddress = 'SuggestedAddress',
  InvalidAddress = 'InvalidAddress',
  OverRideAddress = 'AllowOverrideAddress',
  DefaultAddress = 'DefaultAddress',
}

const useValidateAddress = (
  userEnteredAddress: AddressInput,
  channelType: ChannelType,
  type?: AddressValidationType,
) => {
  const [{ data, fetching: loading }, executeQuery] = useQuery<Query>({
    query: ValidateAddressV2,
    requestPolicy: 'cache-and-network',
    variables: {
      input: {
        address: userEnteredAddress,
        channelType: channelType,
        type: type,
      },
    },
    pause: true,
  });

  useEffect(() => {
    if (userEnteredAddress?.addressLine1) {
      executeQuery();
    }
  }, [executeQuery, userEnteredAddress]);

  const [addressVerification, setAddressVerificationData] = useState<{
    fullAddress?: SuggestedAddress;
    addressType?: AddressView | undefined;
  }>();

  const showAddressVerification = (addressType: AddressView) => {
    setAddressVerificationData({
      fullAddress: data && (data?.validateAddressV2 as SuggestedAddress),
      addressType: addressType,
    });
  };
  const resetAddressVerification = () => {
    setAddressVerificationData({ addressType: AddressView.DefaultAddress });
  };
  useEffect(() => {
    switch (data?.validateAddressV2.__typename) {
      case Typenames.AddressValidationError:
        break;
      case Typenames.SuggestedAddress:
        showAddressVerification(AddressView.SuggestedAddress);
        break;
      case Typenames.InvalidAddress:
        showAddressVerification(AddressView.InvalidAddress);

        break;
      case Typenames.AllowOverrideAddress:
        showAddressVerification(AddressView.OverRideAddress);
        break;

      case Typenames.ValidAddress: {
        showAddressVerification(AddressView.FormAddress);
        break;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return {
    loading: loading,
    validateResponse: data,
    addressVerification,
    resetAddressVerification,
  };
};

export default useValidateAddress;
